// extracted by mini-css-extract-plugin
var _1 = "ScrollAreaDefault__area--X8vY0";
var _2 = "ScrollAreaDefault__content--fSP7d";
var _3 = "ScrollAreaDefault__pos--UthFT";
var _4 = "ScrollAreaDefault__xBar--u6V2p";
var _5 = "ScrollAreaDefault__xThumb--qvk2Y";
var _6 = "ScrollAreaDefault__yBar--qPojq";
var _7 = "ScrollAreaDefault__yThumb--ufmMR";
export { _1 as "area", _2 as "content", _3 as "pos", _4 as "xBar", _5 as "xThumb", _6 as "yBar", _7 as "yThumb" }
